import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

@Component({})
export default class CensusFooter extends Vue {
  @Getter("config", patientNamespace)
  config!: any;

  @Getter("vars", patientNamespace)
  vars!: any;

  @Getter("alerts", patientNamespace)
  alerts!: any;

  @Getter("patients", patientNamespace)
  patients!: Array<Patient>;

  @Getter("towerMode", patientNamespace)
  towerMode!: boolean;

  @Getter("serverTowerMode", patientNamespace)
  serverTowerMode!: boolean;

  @Action("showPopup", navigationNamespace)
  showPopup!: Function;

  get isTower() {
    return this.towerMode && this.serverTowerMode;
  }

  get legendItems() {
    const legend = !this.isTower
      ? this.config.census.legend
      : this.config.census.legendTower;
    const activeLegend = legend.filter(
      (f: any) =>
        f.paths != null &&
        f.paths[0] != null &&
        this.activeIcons.some(
          a => a.replace(".png", "") === f.paths[0].replace(".png", "")
        )
    );
    return activeLegend;
  }

  get activeIcons() {
    const result = [];
    const map = new Map();
    if (this.alerts != null) {
      const activeIcons = this.alerts
        .filter((f: any) => f.method > 0)
        .map((a: any) => a.icon);
      for (const item of activeIcons) {
        if (!map.has(item)) {
          map.set(item, true);
          result.push(item);
        }
      }
    }
    return result;
  }

  get censusCount(): string {
    const len = this.patients.length;
    const full = this.patients.filter(p => !p.census.roomEmpty).length;
    if (len > full) return full.toString() + "/" + len.toString();
    else return len.toString();
  }

  get colorLegend() {
    const vars = this.vars;
    if (this.config.census.colorLegend && vars && vars.caseState) {
      return this.config.census.colorLegend
        .filter((entry: any) => {
          // Must have a caseState in vars
          return vars.caseState[entry.caseState];
        })
        .map((entry: any) => {
          return {
            // Use config label if provided else default to vars
            label: entry.label || vars.caseState[entry.caseState].label,
            color: vars.caseState[entry.caseState].color
          };
        });
    }

    return [];
  }

  get isMobileThin() {
    return (
      this.$vuetify.breakpoint.smAndDown && this.$vuetify.breakpoint.width < 510
    );
  }
  get fontSize() {
    return this.isMobileThin ? "caption" : "body-1";
  }
}
